import { Stack } from '@mantine/core';
import { Skeleton } from '../ui';

/**
 * LoadingState — consistent skeleton wrapper for whole-page loading. Renders
 * 3 stacked rows by default; tune `rows` for tighter views.
 */
export function LoadingState({ rows = 3, height = 36 }: { rows?: number; height?: number }) {
  return (
    <Stack gap="md">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={height} radius="md" />
      ))}
    </Stack>
  );
}
